import AbstractItemTemplate from "../AbstractItemTemplate.js";
import TranslatedString from "../../../TranslatedString.js";

/**
 * Abstract report template column.
 *
 * @abstract
 * @param {TranslatedString} [spec.customTitle] - Optional title
 * overriding the default one.
 */
export default class AbstractColumnTemplate extends AbstractItemTemplate {
	constructor({ customTitle } = {}) {
		super(...arguments);
		this._customTitle = customTitle;
	}

	getCustomTitle() {
		return this._customTitle;
	}

	findColumnRecursively({ predicate: _predicate }) {
		return undefined;
	}

	// Parameter should be undefined or null to indicate no custom
	// title, i.e., use default title.
	setCustomTitle(title) {
		this._customTitle = title;
	}

	getAllSimilarItems({ report }) {
		return report.getColumns();
	}

	addTo(parent, sibling) {
		return parent.addColumn(this, sibling);
	}

	removeFrom(parent) {
		return parent.removeColumn(this);
	}

	isColumn() {
		return true;
	}

	isPeriodColumn() {
		return false;
	}

	isReferenceForecastColumnTemplate() {
		return false;
	}

	isPredictedForecastColumnTemplate() {
		return false;
	}

	isCurrentPeriodForecastColumnTemplate() {
		return false;
	}

	isRepeatingColumnTemplate() {
		return false;
	}

	accept(visitor) {
		return visitor.visitAbstractColumnTemplate(this);
	}

	_interpretationSpec() {
		const spec = super._interpretationSpec(...arguments);

		spec.customTitle = this._customTitle;

		return spec;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.columnType = this.getType();
		properties.customTitle = this._customTitle;

		return properties;
	}

	static transformMaterializationData(data) {
		data.customTitle = TranslatedString.materialize(data.customTitle);
	}
}
